import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { H2 } from '../components/H2';
import { BRAZE_EVENT } from '../constants/braze';
import { Bridge } from '../plugins/bridge';
import { ContentInfoEventProperties, ContentTabEventProperties } from '../types/amplitudeEventProperties';

function lookbook_clicked(isMale : boolean) {
  const content = {
    content_tab : "룩북",
    content_id : isMale ? '2023 FW MAN' : '2023 FW WOMAN',
    content_name : isMale ? '2023 FW MAN' : '2023 FW WOMAN'
  }

  Bridge.sendAmplitude('content_clicked', content);
  // Bridge.sendBraze(BRAZE_EVENT.CONTENT_ITEM_CLICKED, content);
}

export const LookbookPage = () => {
  const [leftHover, setLeftHover] = useState(false);
  const [rightHover, setRightHover] = useState(false);

  useEffect(() => {
    const contentEventProperties : ContentTabEventProperties = {
      content_tab : "룩북"
    }
    Bridge.sendAmplitude('content_list_page_viewed', contentEventProperties);
  
  }, []);

  return (
    <div className="grid xl:grid-cols-2 -mx-4 -mb-10">
      <Link
        to="/lookbook/2023fw-men"
        onMouseOver={() => setLeftHover(true)}
        onMouseLeave={() => setLeftHover(false)}
        className="relative"
        onClick={()=>{lookbook_clicked(true)}}
      >
        <img
          src="https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/overview/2023fw/ss23-lookbook-landing-men.jpg/ss23-lookbook-landing-men.jpg/carhartt%3Adesktoplookhalf"
          alt=""
          className="w-full h-full object-cover"
        />

        {/* Mobile Text */}
        <div
          className={`md:hidden absolute top-0 w-full h-full text-white grid place-content-center text-center space-y-2
            
            `}
        >
          <H2 className="">남성 룩북</H2>
          <p className="">가을/겨울 2023</p>
        </div>

        {/* Desktop Hover Text */}
        <div
          className={`absolute top-0 w-full h-full bg-littleblack text-white grid place-content-center text-center space-y-2
            transition transform ${
              leftHover
                ? 'ease-in-out duration-500 opacity-100 cursor-pointer'
                : 'ease-in duration-250 opacity-0 pointer-events-none'
            }
            `}
        >
          <H2 className="">남성 룩북</H2>
          <p className="">가을/겨울 2023</p>
        </div>
      </Link>
      <Link
        to="/lookbook/2023fw-women"
        onMouseOver={() => setRightHover(true)}
        onMouseLeave={() => setRightHover(false)}
        className="relative"
        onClick={()=>{lookbook_clicked(false)}}
      >
        <img
          src="https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/overview/2023fw/ss23-lookbook-landing-women.jpg/ss23-lookbook-landing-women.jpg/carhartt%3Adesktoplookhalf"
          alt=""
          className="w-full h-full object-cover"
        />

        {/* Mobile Text */}
        <div
          className={`md:hidden absolute top-0 w-full h-full text-white grid place-content-center text-center space-y-2
            
            `}
        >
          <H2 className="">여성 룩북</H2>
          <p className="">가을/겨울 2023</p>
        </div>

        {/* Desktop Hover Text */}
        <div
          className={`absolute top-0 w-full h-full bg-littleblack text-white grid place-content-center text-center space-y-2
            transition transform ${
              rightHover
                ? 'ease-in-out duration-500 opacity-100 cursor-pointer'
                : 'ease-in duration-250 opacity-0 pointer-events-none'
            }
            `}
        >
          <H2 className="">여성 룩북</H2>
          <p className="">가을/겨울 2023</p>
        </div>
      </Link>
    </div>
  );
};
